import { Component, input } from '@angular/core'
import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'
import type { LucideIcon } from '@awork/_shared/directives/icons/types'

/** Shared empty state for mobile lists and pickers. Loading is owned by the caller. */
@Component({
  selector: 'aw-empty-message',
  templateUrl: './empty-message.component.html',
  styleUrl: './empty-message.component.scss',
  imports: [IconsDirective]
})
export class EmptyMessageComponent {
  readonly shown = input(true)
  readonly icon = input<LucideIcon>('circle-check')
  readonly text = input('')
}
